/**
 * Subscribe to a CSS media query from React.
 *
 * **Layout does not belong here.** Where something sits at a given width is
 * Tailwind's job — `lg:static`, `lg:hidden` — and duplicating that in JavaScript
 * gives two answers that drift, with the JavaScript one arriving a frame late.
 * This is for the cases where *behaviour* differs, not appearance: the
 * navigation drawer has open/closed state that stops meaning anything once it
 * becomes a permanent rail, and state has to be told.
 */

import { useEffect, useState } from "react";

export function useMediaQuery(query: string): boolean {
  const [matches, setMatches] = useState(() =>
    typeof window !== "undefined" && typeof window.matchMedia === "function"
      ? window.matchMedia(query).matches
      : false,
  );

  useEffect(() => {
    if (
      typeof window === "undefined" ||
      typeof window.matchMedia !== "function"
    )
      return;

    const list = window.matchMedia(query);
    const onChange = (event: MediaQueryListEvent) => setMatches(event.matches);

    setMatches(list.matches);
    list.addEventListener("change", onChange);
    return () => list.removeEventListener("change", onChange);
  }, [query]);

  return matches;
}
